import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { TagApi } from 'api';
import type { Tag } from 'api/methods/TagApi';

/**
 * [Tag] Query key 생성
 * --
 */
export const tagQueryKeys = createQueryKeys('tag', {
  getTag: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getTags: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Tag] 태그 전체 조회
 * --
 */
export const useGetTags = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: tagQueryKeys.getTags(params).queryKey,
    queryFn: () => TagApi.getTags(params),
    ...options,
  });
  return data;
};

/**
 * [Tag] 태그 상세 조회
 * --
 */
export const useGetTag = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: tagQueryKeys.getTag(idx, params).queryKey,
    queryFn: () => TagApi.getTag(idx, params),
  });

  return data;
};

/**
 * [Tag] 태그 생성
 * --
 */
export const useCreateTag = (body: Tag) => {
  const { mutateAsync: createTag, ...result } = useMutation({
    mutationFn: (variables: Tag) => TagApi.createTag(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createTag, ...result };
};

/**
 * [Tag] 태그 수정
 * --
 */
export const useUpdateTag = (body: Tag) => {
  const { mutateAsync: updateTag, ...result } = useMutation({
    mutationFn: (variables: Tag) => TagApi.updateTag(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateTag, ...result };
};

/**
 * [Tag] 태그 삭제
 * --
 */
export const useDeleteTag = (idx: number) => {
  const { mutateAsync: deleteTag, ...result } = useMutation({
    mutationFn: (variables: number) => TagApi.deleteTag(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteTag, ...result };
};
